var _path, _path2, _path3, _path4, _path5, _path6;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcDrive(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.0013 7.87141L7.92478 4.20676C7.99373 4.13656 8.07305 4.09052 8.15238 4.05957C7.54001 4.26111 7.25904 4.94875 7.25904 4.94875L3.46549 11.6417C3.41212 11.8516 3.39729 12.041 3.40396 12.2078H7.54446L10.0013 7.87141Z",
    fill: "#34A853"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10.0012 7.87141L12.4581 12.2078H16.5986C16.6053 12.041 16.5904 11.8516 16.5371 11.6417L12.7435 4.94875C12.7435 4.94875 12.4618 4.26111 11.8502 4.05957C11.9288 4.09052 12.0088 4.13656 12.0778 4.20676L10.0012 7.87141Z",
    fill: "#FBBC05"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M10.0012 7.87107L12.0777 4.20642C12.0088 4.13622 11.9287 4.09018 11.8501 4.05923C11.7597 4.02979 11.6626 4.01017 11.5573 4.00488H11.4476H8.55478H8.44506C8.34052 4.00941 8.24267 4.02904 8.15222 4.05923C8.07364 4.09018 7.99357 4.13622 7.92462 4.20642L10.0012 7.87107Z",
    fill: "#188038"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M7.54513 12.207L5.4923 15.8302C5.4923 15.8302 5.42409 15.797 5.33142 15.7283C5.62278 15.9524 5.90598 16 5.90598 16H13.9683C14.4131 16 14.5058 15.8302 14.5058 15.8302C14.5072 15.8294 14.508 15.8287 14.5095 15.8279L12.4581 12.207H7.54513Z",
    fill: "#4285F4"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M7.54516 12.207H3.40466C3.42542 12.6992 3.63893 12.9868 3.63893 12.9868L3.79462 13.257C3.80574 13.2728 3.81241 13.2819 3.81241 13.2819L4.15121 13.8767L4.91185 15.2006C4.93409 15.2542 4.96004 15.3033 4.98747 15.3501C4.99785 15.366 5.00748 15.3833 5.01861 15.3984C5.02157 15.4029 5.02454 15.4075 5.0275 15.412C5.12165 15.5448 5.22693 15.6475 5.3322 15.7283C5.42487 15.7977 5.49308 15.8302 5.49308 15.8302L7.54516 12.207Z",
    fill: "#1967D2"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M12.4581 12.207H16.5986C16.5779 12.6992 16.3644 12.9868 16.3644 12.9868L16.2087 13.257C16.1976 13.2728 16.1909 13.2819 16.1909 13.2819L15.8521 13.8767L15.0914 15.2006C15.0692 15.2542 15.0433 15.3033 15.0158 15.3501C15.0054 15.366 14.9958 15.3833 14.9847 15.3984C14.9817 15.4029 14.9788 15.4075 14.9758 15.412C14.8816 15.5448 14.7764 15.6475 14.6711 15.7283C14.5784 15.7977 14.5102 15.8302 14.5102 15.8302L12.4581 12.207Z",
    fill: "#EA4335"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcDrive);
export default __webpack_public_path__ + "static/media/ic-drive.6bb9710dabbf004d226246d2be419877.svg";
export { ForwardRef as ReactComponent };